import TanoCharacter from '../Eleve/TanoCharacter';

/**
 * Tano sur l'écran projeté — la mascotte que les élèves connaissent de
 * l'Espace Élève (skins par défaut : aucun contexte requis).
 *   variant 'idle'   : respiration native de TanoCharacter (écran d'attente)
 *   variant 'entree' : slide-up + rebond one-shot (classe complète, reveal)
 *   variant 'danse'  : wiggle + bounce ×3 puis s'arrête (reveal ≥ 70 %)
 *   variant 'fete'   : danse douce en boucle (écran final / podium)
 */
const VARIANT_CLASS = {
  idle: '',
  entree: 'proj-tano-in',
  danse: 'proj-tano-danse',
  fete: 'proj-tano-fete',
};

const TanoProjo = ({ mood = 'joy', size = 90, variant = 'entree' }) => (
  <div className={`flex-shrink-0 ${VARIANT_CLASS[variant] || ''}`} aria-hidden="true">
    <TanoCharacter mood={mood} size={size} />
  </div>
);

export default TanoProjo;
